import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

export const getIsOpenModal = createSelector(
    getModel,
    (model) => model.isOpenModal,
);

export const getStep = createSelector(getModel, (model) => model.step);

export const getInitialValues = createSelector(
    getModel,
    (model) => model.initialValues,
);

export const getProjects = createSelector(getModel, (model) => model.projects);

export const getIsFetchingProjects = createSelector(
    getProjects,
    (projects) => projects.isFetching,
);

export const getProjectsData = createSelector(
    getProjects,
    (projects) => projects?.data?.data,
);

export const getProjectsPagination = createSelector(
    getProjects,
    (value) => value?.data?.pagination,
);

export const getProjectsErrors = createSelector(
    getProjects,
    (value) => value.errors,
);

export const getShowEmptyState = createSelector(
    getModel,
    (model) => model.showEmptyState,
);
